import React, { Component } from 'react';
import '../../../../styles/variables.css';
import {connect} from 'react-redux';
import {manageVacancy} from '../../../../actions/_admin_actions';
import database from '../../../../firebase/firebase';
import {ShowNotification} from '../../../../components/HandleNotifications';
import {NotificationContainer} from 'react-notifications';
import JobDetailModal from '../components/JobDetailModal';

class DeleteVacancy extends Component {

    state = {        
        renderModal: false,
        showModal: false,
        currentJob: {}}

    manageVacancy = (data) => {
        const newValues = this.props.vacancies.filter((job) => data.jobID === job.jobID)
        newValues[0].Status = false;
        database
            .collection(`companies`).doc(`${data.vacancyOwner}/jobs/${data.jobID}`)
            .update({Status: false})
            .then(()=>{
                return database.collection('vacancies').doc(data.jobID).delete();
            })
            .then(() => {
                this.props.updateJobs(this.props.vacancies)
                ShowNotification('success',`Se eliminó la vacante de la plataforma correctamente` ,'Todo bien')
            });
    }
    showMore = (data)=>{
        this.setState({
            currentJob: data,
            showModal: true,
            renderModal: true
        })
    }
    ToggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            renderModal: !prevState.renderModal
        }));
    }

    render(){
        return(
            <div className="container">
                <div className='a-main-card'>
                    <div className="adt">
                        <p className="-title">Quitar Vacantes de la Plataforma</p>
                    </div>
                   {this.props.vacancies.map((job) => {
                       if(job.Status && job.Permission === "accept"){
                           return <div className="a-inline-dash-card" key={job.jobID}>
                               <div className="-content">
                                        {job.img === "" ? null :
                                         <img className="-profile" src={job.img} alt="c-logo"/>}
                                   <div className="-info">
                                       <p className="d-job-title">{job.jobTitle}</p>
                                       <p className="d-companyName">{job.companyName}</p>
                                       <p className="d-hireName">{job.contratc}</p>
                                    <p className="d-see-more" onClick={() => { this.showMore(job) }}>Ver más</p>
                                   </div>
                                   <div className="-desc">
                                       <p className="d-job-title">En la plataforma desde: </p>
                                       <p className="d-companyName">-- {` ${job.postedFrom.substring(0, job.postedFrom.length - 1)} `} --</p>
                                   </div>
                                   <div className="-amount">
                                       <p className="d-job-title"># Postulantes </p>
                                       <p className="d-job-title">-- {job.applicantsCount} --</p>
                                   </div>
                               </div>
                               <div className="-a-links">
                                   <button className="-b-accept" onClick={() => this.manageVacancy(job)}
                                   >Eliminar</button>
                               </div>
                           </div>
                       }
                   })} 
                   <NotificationContainer />
                    {this.state.renderModal ? <JobDetailModal data={this.state.currentJob} 
                    open={this.state.showModal} close={this.ToggleModal}/> : null}
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateJobs: (newVals) => dispatch(manageVacancy(newVals))
})
const mapStateToProps = (state) => ({
    vacancies: state.admin
})


export default connect(mapStateToProps, mapDispatchToProps)(DeleteVacancy);